import { Field } from "formik";
import React, { useState, useRef } from "react";

const TextInput = ({ name, value, handleChange, placeholder, isDisabled = false, bgColor= "bg-gray-50", classes = "" ,type = "text", legend=false, onKeyDown }) => {
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef(null);

  const handleFieldsetClick = () => {
    if (!isFocused && !value) {
      inputRef.current.focus();
    }
  };

  return (
    legend ? (
    <fieldset
      className={`relative border ${isFocused ? "border-primary" : "border-gray-500"} border-gray-300 rounded-md w-full border-2 px-2 h-10 flex items-center`}
      onClick={handleFieldsetClick}
    >
      {/* Floating Label (Legend) */}
      <legend
        className={`absolute left-2 transition-all duration-200 ${bgColor === "bg-gray-100" ? "bg-gray-100" : "bg-gray-50"} px-1 ${
          isFocused || value
            ? "-top-3 text-sm text-primary"  // Moves up when focused or filled
            : "top-1/2 -translate-y-1/2 text-sm text-gray-400" // Perfectly centers when empty
        }`}
      >
        {placeholder}
      </legend>

      <Field
        type={type}
        name={name}
        value={value}
        onChange={handleChange}
        disabled={isDisabled}
        className={`${classes} w-full border-none h-full outline-none bg-transparent pt-2 px-1`}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        onKeyDown={onKeyDown}
        innerRef={inputRef}
      />
    </fieldset> 
    ) : 
    <Field 
        type={type}
        name={name} 
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        disabled={isDisabled}
        className={`${classes} w-64 border border-gray-300 rounded-[0.3rem] p-1 h-[2.4rem]`}
        onKeyDown={onKeyDown}
    />
  );
};

export default TextInput;